import { render, staticRenderFns } from "./UserSet.vue?vue&type=template&id=00d2509b&"
import script from "./UserSet.vue?vue&type=script&lang=js&"
export * from "./UserSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports